import { Image } from '@akin-home/amplify';
import { fetchImageUrl } from '@akin-home/images/frontend';
import { useQuery } from 'react-query';

interface Params {
  image?: Image;
  edits?: any;
  config?: any;
}

export const useImageUrl = (params: Params) => {
  const { image, edits, config } = params;

  const key = edits
    ? ['image', image?.data?.key, edits]
    : ['image', image?.data?.key];

  const data = useQuery(
    key,
    async () =>
      image?.data?.key
        ? await fetchImageUrl({ key: image.data.key, edits, config })
        : undefined,
    {
      enabled: !!image && !!image.data?.key,
    }
  );

  return data;
};
